import clsx from 'clsx';
import { ActionLink } from 'app/_shared'

import styles from './ModalHeader.module.scss'

export default ({ children, close, className }) => (
  <div className={clsx(styles.header, className)}>
    {children}
    <ActionLink className={styles.close} onClick={close}>
      &times;
    </ActionLink>
  </div>
)
